import React, { Component } from 'react';
import axios from "axios";
import { connect } from "react-redux";
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import Loading from "../../admin/components/Loading";
import { MDBDataTable } from "mdbreact";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { dateFormat, getStoreType } from '../../../dynamicController';
import i18n from "i18next";
import PromotionCard from '../../admin/components/setting/PromotionCard';

const mySwal = withReactContent(Swal);

const STORETYPE = getStoreType()

class News extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toggled: false,
            loading: false,
            data: [],
            distributorId: ""
        };
    };

    componentDidMount() {
        if (!this.props.client || !this.props.client.news_setting) {
            return this.props.history.push('/client');
        } else if (this.props.location.state) {
            if (this.props.location.state.distributorId) {
                this.setState({
                    ...this.state,
                    loading: true,
                    distributorId: this.props.location.state.distributorId
                });

                axios
                    .post("/api/admin/setting/getNews", { id: this.props.location.state.distributorId, role: "distributor" }, { headers: { "Content-Type": "application/json", "auth-token": this.props.token } })
                    .then(res => {
                        this.setState({
                            ...this.state,
                            data: res.data,
                            loading: false
                        });
                    })
                    .catch(err => {
                        this.setState({
                            ...this.state,
                            loading: false
                        });
                        mySwal.fire(i18n.t("Error"), i18n.t(err.response.data.error), "error");
                    });
            }
        }
    }

    handleToggle = () => this.setState({ ...this.state, toggled: !this.state.toggled });

    handleSelectDistributor = (e) => {
        let sendThis = {
            id: e.target.value,
            role: "distributor"
        }

        this.setState({
            ...this.state,
            loading: true,
            distributorId: e.target.value
        });

        axios
            .post("/api/admin/setting/getNews", sendThis, { headers: { "Content-Type": "application/json", "auth-token": this.props.token } })
            .then(res => {
                this.setState({
                    ...this.state,
                    data: res.data,
                    loading: false
                });
            })
            .catch(err => {
                this.setState({
                    ...this.state,
                    loading: false
                });
                mySwal.fire(i18n.t("Error"), i18n.t(err.response.data.error), "error");
            });
    }

    deleteNews = id => {
        mySwal.fire({
            title: i18n.t("Confirmation"),
            text: i18n.t("Are you sure you want to delete news?"),
            icon: "question",
            showCancelButton: true,
            cancelButtonText: i18n.t("No"),
            confirmButtonText: i18n.t("Yes"),
            cancelButtonColor: "#d33"
        }).then(click => {

            if (click.isConfirmed && click.value) {
                this.setState({
                    ...this.state,
                    loading: true
                });

                const sendThis = {
                    newsId: id
                };

                axios.post('/api/admin/setting/deleteNews', sendThis, { headers: { "Content-Type": "application/json", "auth-token": this.props.token } })
                    .then(res => {

                        axios
                            .post("/api/admin/setting/getNews", { id: this.state.distributorId, role: "distributor" }, { headers: { "Content-Type": "application/json", "auth-token": this.props.token } })
                            .then(res => {
                                this.setState({
                                    ...this.state,
                                    data: res.data,
                                    loading: false
                                });
                                mySwal.fire(i18n.t("Success"), i18n.t("News deleted successfully"), "success");
                            })
                            .catch(err => {
                                this.setState({
                                    ...this.state,
                                    loading: false
                                });
                                mySwal.fire(i18n.t("Error"), i18n.t(err.response.data.error), "error");
                            });

                    })
                    .catch(err => {
                        this.setState({
                            ...this.state,
                            loading: false
                        });
                        mySwal.fire(i18n.t("Error"), i18n.t(err.response.data.error), "error");
                    });
            }
        });
    }

    render() {

        let tableData = {
            columns: [
                {
                    label: i18n.t("Title"),
                    field: "title",
                    sort: "asc"
                },
                {
                    label: i18n.t("Start Date"),
                    field: "startDate",
                    sort: "asc"
                },
                {
                    label: i18n.t("End Date"),
                    field: "endDate",
                    sort: "asc"
                },
                {
                    label: i18n.t("Action"),
                    field: "action"
                }
            ],
            rows: []
        };

        if (STORETYPE === "cleanpro") {
            tableData = {
                columns: [
                    {
                        label: i18n.t("Title"),
                        field: "title",
                        sort: "asc"
                    },
                    {
                        label: i18n.t("Short Description"),
                        field: "short_description",
                        sort: "asc"
                    },
                    {
                        label: i18n.t("Start Date"),
                        field: "start_date",
                        sort: "asc"
                    },
                    {
                        label: i18n.t("End Date"),
                        field: "end_date",
                        sort: "asc"
                    },
                    {
                        label: i18n.t("Inbox"),
                        field: "inbox",
                        sort: "asc"
                    },
                    {
                        label: i18n.t("Promotion Banner"),
                        field: "promotion",
                        sort: "asc"
                    },
                    {
                        label: i18n.t("Action"),
                        field: "action"
                    }
                ],
                rows: []
            };
        }

        if (this.state.data.length) {
            for (let i = 0; i < this.state.data.length; i++) {
                const dataObject = {
                    title: this.state.data[i].title,
                    start_date: this.state.data[i].start_date ? dateFormat(this.state.data[i].start_date) : "-",
                    end_date: this.state.data[i].end_date ? dateFormat(this.state.data[i].end_date) : "-",
                    short_description: this.state.data[i].short_description ? (
                        <div dangerouslySetInnerHTML={{ __html: this.state.data[i].short_description }}></div>
                    ) : "-",
                    inbox: this.state.data[i].inbox ? i18n.t("Yes") : i18n.t("No"),
                    promotion: this.state.data[i].promotion ? i18n.t("Yes") : i18n.t("No"),
                    action: (
                        <div>
                            <i className="bi bi-pencil-square" onClick={() => this.props.history.push("/client/news/edit", { newsId: this.state.data[i].id, distributorId: this.state.distributorId })}></i>
                            <i className="bi bi-trash3-fill ms-3" onClick={() => this.deleteNews(this.state.data[i].id)}></i>
                        </div>
                    )
                };
                tableData.rows.push(dataObject);

            }
        }

        const renderList = () => {

            if (this.state.loading) {
                return (
                    <Loading />
                );
            } else {
                if (!this.state.data.length) {
                    return (
                        <div className="text-center">
                            <h1> - {i18n.t("NO NEWS")} - </h1>
                        </div>
                    );
                } else {
                    return (
                        <MDBDataTable data={tableData} noBottomColumns striped hover responsive bordered />
                    );
                }
            }
        }

        return (
            <div className="admin-page-container">
                <Sidebar toggled={this.state.toggled} setToggled={this.handleToggle} />

                <div className="admin-page">
                    <Topbar handleToggle={this.handleToggle} />

                    <div className="admin-content">

                        <div className="text-center">
                            <h3>{i18n.t("News")}</h3>
                        </div>
                        <div className="pb-2">
                            <label htmlFor="distributorId">{i18n.t("Select Distributor")}: </label>
                            <select id="distributorId" name="distributorId" className="browser-default form-select" value={this.state.distributorId} onChange={this.handleSelectDistributor}>
                                <option disabled value="">{i18n.t("Select Distributor")}</option>
                                {
                                    this.props.client.distributor.map(distributor => <option key={distributor.id} value={distributor.id}>{distributor.name}</option>)
                                }
                            </select>
                        </div>

                        {
                            STORETYPE !== "cleanpro" && STORETYPE !== "washup" && STORETYPE !== "jomcuci" && this.state.distributorId ?
                                <PromotionCard
                                    id={this.state.distributorId}
                                    role="distributor"
                                    token={this.props.token}
                                />
                                : null
                        }

                        {
                            this.state.distributorId && !this.state.loading ? (
                                <div className="card">
                                    <div className="card-header d-flex justify-content-between">
                                        <h5 className="card-title">{i18n.t("News")}</h5>

                                        <button className="btn btn-primary" onClick={() => this.props.history.push("/client/news/add", { distributorId: this.state.distributorId })}>
                                            {i18n.t("Add News")}
                                        </button>
                                    </div>

                                    <div className="card-body">
                                        {
                                            renderList()
                                        }
                                    </div>

                                </div>
                            ) : this.state.loading ? <Loading />
                                : null
                        }
                    </div>
                </div>
            </div>
        );
    };
};

const mapStateToProps = state => {
    return {
        client: state.client.client,
        token: state.client.token
    };
};

export default connect(mapStateToProps, null)(News);